module.exports = __webpack_public_path__ + "static/media/delete_icon.bae33308.png";